import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { isUndefined } from "lodash-es";

import { COOKIE_CONSENT_ACTION_TYPE } from "./cookie-consent.action";
import { CookieConsentState } from "./cookie-consent.model";

const INITIAL_STATE: CookieConsentState = {
	isConsentGiven: undefined,
	isAccepted: false,
	isEnabled: false,
	ConsentGroup: undefined,
};

export function cookieConsentReducer(state = INITIAL_STATE, action: ActionWithPayload): CookieConsentState {
	switch (action.type) {
		case COOKIE_CONSENT_ACTION_TYPE.set: {
			return updateState(state, {
				isConsentGiven: !isUndefined(action.payload),
				isAccepted: !!action.payload,
			});
		}
		case COOKIE_CONSENT_ACTION_TYPE.setEnabled: {
			return updateState(state, {
				isEnabled: action.payload,
			});
		}
		case COOKIE_CONSENT_ACTION_TYPE.updateSuccess: {
			return updateState(state, {
				ConsentGroup: action.payload,
			});
		}
		default: {
			return state;
		}
	}
}
